<template>
  <div>
    <div class="info">
      <!-- <p><span>备案流水号：</span> {{fillingDetails.serialCode}}</p> -->
      <p><span>申请日期：</span> {{formatTime(fillingDetails.startDate)}}</p>
      <p><span>备案进度：</span> {{fillingDetails.step}}</p>
      <p><span>处理机构：</span> {{dealOrg}}</p>
    </div>
       <el-button @click="brank" size="medium" style="margin-bottom:10px;">返回</el-button>
    <div class="progress-list">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="日期" width="200">
          <template slot-scope="scope">
            <span>{{ formatTime(scope.row.endDate) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="step" label="事项" width="200">
        </el-table-column>
        <el-table-column prop="orgName" label="机构" width="200">
        </el-table-column>
        <el-table-column prop="creatorName" label="处理人" width="180">
        </el-table-column>
        <el-table-column prop="creator" label="联系方式" width="180">
          <template slot-scope="scope">
            <span>{{ hidePhone(scope.row.creator) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="opinion" label="结果" width="180">
        </el-table-column>
        <el-table-column prop="remark" label="备注说明" min-width="200">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import fillingInfo from "./../../data/basic/weather/filling";
import moment from "moment";
export default {
  data() {
    return {
      tableData: [],
      fillingDetails: {},
      dealOrg: ""
    };
  },
  created() {
    this.planId = this.$route.query.planId;
    if (!this.planId) return;
    this.fillingInit({
      planId: this.planId,
      page:0,
      size:10000,
      sort:'endDate,desc'
    });
    this.fillingInfo({
      planId: this.planId
    });
    let instanceId = this.$route.query.instanceId;
    let processKey = this.$route.query.processKey;
    if (!instanceId || !processKey) return;
    this.fillingDealOrg({
      instanceId: instanceId,
      processKey: processKey
    });
  },
  methods: {
    //隐藏号码
    hidePhone(val){
      var reg = /^(\d{3})\d*(\d{4})$/;
      return val.replace(reg,'$1****$2')
    },
    brank() {
      sessionStorage.changeBrank = 1;
      this.$router.push("/");
    },
    // 进度
    fillingInit(data) {
      (async () => {
        let datas = await fillingInfo.get_fillingProgress(data);
        if (datas.status) {
          this.tableData = datas.data.content;
        }
      })();
    },
    // 信息
    fillingInfo(data) {
      (async () => {
        let datas = await fillingInfo.get_progressInfo(data);
        if (datas.status) {
          this.fillingDetails = datas.data;
        }
      })();
    },
    // 处理机构信息
    fillingDealOrg(data) {
      (async () => {
        let datas = await fillingInfo.get_progressDealOrg(data);
        if (datas.status) {
          let orgList = datas.data;
          this.dealOrg = "";
          if (orgList === undefined || orgList.length == 0) {
            return;
          }
          orgList.forEach(element => {
            this.dealOrg += element.name +" ("+ element.admin +"， "+(element.phone?element.phone:element.adminTel)+");"
          });
          if(this.dealOrg.length > 1){
            this.dealOrg = this.dealOrg.slice(0,-1);
          }
        }
      })();
    },
    // 格式化时间
    formatTime(time) {
      if (!time) return ''
      return moment(time).format("YYYY/MM/DD HH:mm:ss");
    }
  }
};
</script>
<style lang="stylus" scoped>
.info {
  line-height: 30px;
  color: #666;
  margin-bottom: 20px;
  padding-left: 3px;

  p {
    font-size: 14px;
    color: #1f2d3d;
  }

  span {
    display: inline-block;
    width: 100px;
    text-align: right;
    margin-right: 10px;
  }
}

.brank {
  // float: right;
  background: #30a5db;
  color: #fff;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// fillingProgress.vue?2e165e68